import { Injectable, isDevMode } from '@angular/core';

const KEY = 'authVoluntaryToken';

@Injectable({ providedIn: 'root' })
export class TokenVoluntaryService {
  storage = isDevMode() ? window.localStorage : window.sessionStorage;

  hasToken() {
    return !!this.getToken();
  }

  setToken(token: string) {
    this.storage.setItem(KEY, token);
  }

  getToken() {
    return this.storage.getItem(KEY);
  }

  removeToken() {
    this.storage.removeItem(KEY);
  }
}
